import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import classnames from "classnames";
import { Box } from "../../Box/index.js";
import { Icon } from "../../Icon/index.js";
import { Label } from "../common/index.js";
import { useStyles } from "./RadioInputComplexLabel.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function RadioInputComplexLabel_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else RadioInputComplexLabel_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const RadioInputComplexLabel = (t0)=>{
    const $ = c(58);
    let allowClear;
    let items;
    let label;
    let onChange;
    let render;
    let renderFooter;
    let rest;
    let t1;
    let t2;
    let value;
    if ($[0] !== t0) {
        ({ items, value, onChange, render, renderFooter, variant: t1, label, required: t2, allowClear } = t0), rest = _object_without_properties(t0, [
            "items",
            "value",
            "onChange",
            "render",
            "renderFooter",
            "variant",
            "label",
            "required",
            "allowClear"
        ]);
        $[0] = t0;
        $[1] = allowClear;
        $[2] = items;
        $[3] = label;
        $[4] = onChange;
        $[5] = render;
        $[6] = renderFooter;
        $[7] = rest;
        $[8] = t1;
        $[9] = t2;
        $[10] = value;
    } else {
        allowClear = $[1];
        items = $[2];
        label = $[3];
        onChange = $[4];
        render = $[5];
        renderFooter = $[6];
        rest = $[7];
        t1 = $[8];
        t2 = $[9];
        value = $[10];
    }
    const variant = void 0 === t1 ? "primary" : t1;
    const required = void 0 === t2 ? false : t2;
    const { classes } = useStyles();
    let t3;
    if ($[11] !== label || $[12] !== required) {
        t3 = label && /*#__PURE__*/ jsx(Label, {
            label: label,
            required: required
        });
        $[11] = label;
        $[12] = required;
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== classes.formRoot) {
        t4 = {
            root: classes.formRoot
        };
        $[14] = classes.formRoot;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== onChange) {
        t5 = (e)=>{
            e.stopPropagation();
            onChange(e.target.value);
        };
        $[16] = onChange;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== allowClear || $[19] !== classes.checkedItem || $[20] !== classes.inputRoot || $[21] !== classes.itemBox || $[22] !== classes.labelRoot || $[23] !== classes.primaryItem || $[24] !== classes.secondaryItem || $[25] !== items || $[26] !== onChange || $[27] !== render || $[28] !== renderFooter || $[29] !== value || $[30] !== variant) {
        let t7;
        if ($[32] !== allowClear || $[33] !== classes.checkedItem || $[34] !== classes.inputRoot || $[35] !== classes.itemBox || $[36] !== classes.labelRoot || $[37] !== classes.primaryItem || $[38] !== classes.secondaryItem || $[39] !== onChange || $[40] !== render || $[41] !== renderFooter || $[42] !== value || $[43] !== variant) {
            t7 = (item)=>/*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    flexDirection: "column",
                    gap: "12",
                    bgcolor: "bg.light.primary",
                    className: classnames(classes.itemBox, "secondary" === variant ? classes.secondaryItem : classes.primaryItem, item.value === value && classes.checkedItem),
                    children: [
                        /*#__PURE__*/ jsx(FormControlLabel, {
                            value: item.value,
                            classes: {
                                root: classes.labelRoot
                            },
                            control: /*#__PURE__*/ jsx(Radio, {
                                disableRipple: true,
                                disableFocusRipple: true,
                                disableTouchRipple: true,
                                onClick: ()=>{
                                    if (allowClear && item.value === value) onChange(void 0);
                                },
                                classes: {
                                    root: classes.inputRoot
                                },
                                icon: /*#__PURE__*/ jsx(Icon, {
                                    name: "radio_off",
                                    size: "24",
                                    color: "stroke.primary"
                                }),
                                checkedIcon: /*#__PURE__*/ jsx(Icon, {
                                    name: "radio_on",
                                    size: "24"
                                })
                            }),
                            label: render(item.label),
                            labelPlacement: "end"
                        }),
                        null == renderFooter ? void 0 : renderFooter(item.label, item.value === value)
                    ]
                }, item.value);
            $[32] = allowClear;
            $[33] = classes.checkedItem;
            $[34] = classes.inputRoot;
            $[35] = classes.itemBox;
            $[36] = classes.labelRoot;
            $[37] = classes.primaryItem;
            $[38] = classes.secondaryItem;
            $[39] = onChange;
            $[40] = render;
            $[41] = renderFooter;
            $[42] = value;
            $[43] = variant;
            $[44] = t7;
        } else t7 = $[44];
        t6 = items.map(t7);
        $[18] = allowClear;
        $[19] = classes.checkedItem;
        $[20] = classes.inputRoot;
        $[21] = classes.itemBox;
        $[22] = classes.labelRoot;
        $[23] = classes.primaryItem;
        $[24] = classes.secondaryItem;
        $[25] = items;
        $[26] = onChange;
        $[27] = render;
        $[28] = renderFooter;
        $[29] = value;
        $[30] = variant;
        $[31] = t6;
    } else t6 = $[31];
    let t7;
    if ($[45] !== t6) {
        t7 = /*#__PURE__*/ jsx(Box, {
            display: "flex",
            flexDirection: "column",
            gap: "12",
            children: t6
        });
        $[45] = t6;
        $[46] = t7;
    } else t7 = $[46];
    let t8;
    if ($[47] !== rest || $[48] !== t5 || $[49] !== t7 || $[50] !== value) {
        t8 = /*#__PURE__*/ jsx(RadioGroup, _object_spread_props(_object_spread({}, rest), {
            row: false,
            value: value,
            onChange: t5,
            className: "aqa_radioinput_block",
            children: t7
        }));
        $[47] = rest;
        $[48] = t5;
        $[49] = t7;
        $[50] = value;
        $[51] = t8;
    } else t8 = $[51];
    let t9;
    if ($[52] !== t4 || $[53] !== t8) {
        t9 = /*#__PURE__*/ jsx(FormControl, {
            component: "fieldset",
            classes: t4,
            children: t8
        });
        $[52] = t4;
        $[53] = t8;
        $[54] = t9;
    } else t9 = $[54];
    let t10;
    if ($[55] !== t3 || $[56] !== t9) {
        t10 = /*#__PURE__*/ jsxs(Box, {
            children: [
                t3,
                t9
            ]
        });
        $[55] = t3;
        $[56] = t9;
        $[57] = t10;
    } else t10 = $[57];
    return t10;
};
export { RadioInputComplexLabel };
